(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagnalog_tipoDeleteController',Campagnalog_tipoDeleteController);

    Campagnalog_tipoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Campagnalog_tipo'];

    function Campagnalog_tipoDeleteController($uibModalInstance, entity, Campagnalog_tipo) {
        var vm = this;

        vm.campagnalog_tipo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Campagnalog_tipo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
